import { useRef, useState } from "react";

import { SLIDE_CLASS, SLIDE_DIRECTION, VIEW_MODE } from "../../shared/types";

interface UseSharedRangePickerProps {
  initialYear: number;
  initialViewMode?: VIEW_MODE;
}

export const useSharedRangePicker = ({
  initialYear,
  initialViewMode = VIEW_MODE.Month
}: UseSharedRangePickerProps) => {
  const [year, setYear] = useState(initialYear);
  const [viewMode, setViewMode] = useState<VIEW_MODE>(initialViewMode);
  const [viewVisible, setViewVisible] = useState(true);
  const [slideClass, setSlideClass] = useState<SLIDE_CLASS>(SLIDE_CLASS.Idle);
  const hoverClearTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const cancelHoverClear = () => {
    if (hoverClearTimer.current) {
      clearTimeout(hoverClearTimer.current);
      hoverClearTimer.current = null;
    }
  };

  const animateSlide = (direction: SLIDE_DIRECTION, callback: () => void) => {
    const exitClass =
      direction === SLIDE_DIRECTION.Left
        ? SLIDE_CLASS.ExitLeft
        : SLIDE_CLASS.ExitRight;
    const enterClass =
      direction === SLIDE_DIRECTION.Left
        ? SLIDE_CLASS.EnterLeft
        : SLIDE_CLASS.EnterRight;

    setSlideClass(exitClass);
    setTimeout(() => {
      callback();
      setSlideClass(enterClass);
      setTimeout(() => setSlideClass(SLIDE_CLASS.Idle), 160);
    }, 120);
  };

  const animateFadeView = (callback: () => void) => {
    setViewVisible(false);
    setTimeout(() => {
      callback();
      setViewVisible(true);
    }, 140);
  };

  return {
    year,
    setYear,
    viewMode,
    setViewMode,
    viewVisible,
    slideClass,
    hoverClearTimer,
    cancelHoverClear,
    animateSlide,
    animateFadeView
  };
};
